// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-theme-provider {
  background: rgb(var(--v-theme-background));
  color: rgb(var(--v-theme-on-background));
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VThemeProvider/VThemeProvider.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,wCAAwC;AAC1C","sourcesContent":[".v-theme-provider {\n  background: rgb(var(--v-theme-background));\n  color: rgb(var(--v-theme-on-background));\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
